import {InvListElementType, InvListMapType, InvSearchParamType} from "../interface";

export const invSearchParamInit: InvSearchParamType = {
    keyword: "",
    keywordType: "1",
    limit: 10,
    pageNo: 1,
    statusCodeList: ["1", "2"]
}

export const invListMapInit: InvListMapType = {
    totalCount: 0,
    inventoryList: []
}

export const invListElementInit: InvListElementType = {
    inventoryId: 0,
    vendor: "",
    category: "",
    barcode: "",
    newTxtNmItem: "",
    new_txt_nm_item: "",
    newTxtStndItem: "",
    new_txt_stnd_item: "",
    majorCategory: "",
    subCategory: "",
    inventoryUnit: 0,
    inventoryAmount: 0,
    erpProductImageVO: {},
    currency: ""
}
